// "Show on map" (MAP3): wherever something has a place, a link to it on the map, with its pin
// selected.
import { mapHref, mapSlug, type MapLink } from '@brimstone/shared';
import { Link } from 'react-router';

export function ShowOnMap({
  link,
  character,
  label = 'Show on map',
}: {
  link: MapLink | null | undefined;
  /** The map opens with this character's fog. */
  character?: string | null;
  label?: string;
}) {
  if (!link) return null;
  return (
    <Link to={mapHref(link, character)} className="text-secondary whitespace-nowrap text-accent">
      {label}
    </Link>
  );
}

/** A character's logout spot: their zone's map with their tag selected. */
export function characterSpot(id: string, zone: string | null | undefined): MapLink | null {
  return zone ? { slug: mapSlug(zone), pin: `char:${id}` } : null;
}
